// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';

// bernie
import { ContextStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedComponentProps } from '@shared-ui/localization-context';

// mobx
import { Program } from 'models';

// ui
import { UitkPrimaryFloatingButton, UitkSecondaryButton } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// util
import { modifyLocaleParam } from '../../../util/LocaleParamTransformer';

export interface ProgramCardCTAProps extends LocalizedComponentProps {
  context?: ContextStore;
  isProgramApproved: boolean;
  l10n?: ILocalization;
  program: Program;
  programStatus?: string;
}

export const ProgramCardCTA: React.FunctionComponent<ProgramCardCTAProps> = ({
                                                                               context,
                                                                               isProgramApproved,
                                                                               l10n,
                                                                               program,
                                                                               programStatus,
                                                                             }) => {

  if (program.live) {
    const productButtonText = (isProgramApproved) ? 'go.to.products' : 'preview.products';

    return (
      <UitkText align="center">
        <div>
          <Link
            to={(context?.locale) ? `/${modifyLocaleParam(context.locale)}/products?programName=${program.name}` : null}
            className="a--no-hover">
            <UitkPrimaryFloatingButton text={l10n.formatText(productButtonText)}/>
          </Link>
        </div>

        {(programStatus === null || (programStatus && programStatus === 'UNKNOWN')) && (
          <UitkSpacing margin={{ blockstart: 'four' }}>
            <div>
              {(program.network === 'PARTNERIZE') ? (
                <Link to={(context?.locale) ? program.signUpLink?.replace(':localeName', modifyLocaleParam(context.locale)) : null} className="a--no-hover">
                  <UitkPrimaryFloatingButton text={l10n.formatText('join.program')}/>
                </Link>
              ) : (
                <Link to={{ search: `pwaDialog=joinAffiliateNetwork-${program.name}` }} className="a--no-hover">
                  <UitkPrimaryFloatingButton text={l10n.formatText('join.program')}/>
                </Link>
              )}
            </div>
          </UitkSpacing>
        )}
      </UitkText>
    );
  }

  // program not live
  return <UitkSecondaryButton text={l10n.formatText('common.coming.soon')} isFullWidth={true} disabled={true}/>;
};
